import { ApplicationOperParams } from '@lk/api'
import { ApplicationOperPostParams } from '@lk/api/application/models/oper/oper_post-params.model'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const applicationAccessPermAdd = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] ACCESS_PERM_ADD',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.oper('accesspermadd', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)
export const applicationAccessPermDelete = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] ACCESS_PERM_DELETE',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.oper('accesspermdelete', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)
export const applicationAgreementNumberUpdate = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] AGREEMENT_NUMBER_UPDATE',
  async ({ ...params }, { extra }) => {
    const result = await extra.api.application.oper('agreementnumberupdate', params)

    return result.error
  },
)

export const applicationDmprocess = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] DMPROCESS',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.oper('dmprocess', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationExpire = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] EXPIRE',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.oper('expire', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
export const applicatioExpireUndo = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] EXPIRE_UNDO',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.oper('expireundo', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
export const applicationReturn = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] RETURN',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.oper('return', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
export const applicationScreeningReject = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] SCREENING_REJECT',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.oper('screeningreject', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
export const applicationScreeningRejectUndo = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] SCREENING_REJECT_UNDO',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.oper('screeningrejectundo', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
export const applicationSend = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] SEND',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.oper('send', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationUndoToScreening = createAsyncThunk<any, ApplicationOperParams, ThunkApi>(
  '[APPLICATION/OPER] UNDO_TO_SCREENING',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.oper('undotoscreening', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
